var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBookmarkShadowLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10242_24360)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10242_24360)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7 12.2C15.3075 12.2 14.2 13.3075 14.2 14.7V35.9C14.2 35.962 14.2141 35.9876 14.2177 35.9937C14.2227 36.0022 14.2306 36.0113 14.2458 36.0199C14.2784 36.0386 14.3348 36.0487 14.3981 36.0208L23.5747 31.0335C23.9023 30.8555 24.2977 30.8555 24.6253 31.0335L33.799 36.0193C33.8236 36.0288 33.869 36.0337 33.9291 35.9972C33.9597 35.9787 33.979 35.9569 33.9887 35.9406C33.9966 35.9275 34 35.9162 34 35.9V14.7C34 13.3075 32.8925 12.2 31.5 12.2H16.7ZM12 14.7C12 12.0925 14.0925 10 16.7 10H31.5C34.1075 10 36.2 12.0925 36.2 14.7V35.9C36.2 37.6398 34.3196 38.7397 32.8081 37.9839C32.7969 37.9783 32.7857 37.9725 32.7747 37.9665L24.1 33.252L15.4253 37.9665C15.4143 37.9725 15.4031 37.9783 15.3919 37.9839C13.9473 38.7062 12 37.8127 12 35.9V14.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 20.7H19.2V18.5H29V20.7Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10242_24360",
    x: 6,
    y: 5,
    width: 36.2,
    height: 40.2332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10242_24360"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10242_24360",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10242_24360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookmarkShadowLight);
export default __webpack_public_path__ + "static/media/icon_bookmark_shadow_light.ff30d0c6.svg";
export { ForwardRef as ReactComponent };